import React from "react";
import { styled } from "styled-components";

import { MainContainer, Text } from "../../helpers/StyledComponents";
import TitleHeader from "../../components/Common/TitleHeader";
import SocialSection from "../../components/Common/SocialSection";
import { MobileSize } from "../../constant";

const ContactUs = () => {
  return (
    <>
      <MainContainer>
        <TitleHeader en="CONTACT US" th="ติดต่อเรา" center />
        <ContactCardContainer>
          <CardContainer>
            <Text
              fontSize="16"
              style={{ textAlign: "center", marginBottom: "15px" }}
            >
              <TopicCard>
                <strong>Address / ที่อยู่</strong>
              </TopicCard>
            </Text>
            <Text>
              <strong>Scripture Union Thailand</strong>
              <br /> 274 North Sathorn Road, Bangrak, Bangkok 10500
              <br />
              <strong>คริสตธรรมสัมพันธ์แห่งประเทศไทย</strong>
              <br /> 274 ถนนสาทรเหนือ บางรัก กรุงเทพฯ 10500(ชั้น 4 อาคารหกชั้น
              คริสตจักรสาธร)
            </Text>
          </CardContainer>
          <CardContainer>
            <Text fontSize="16" style={{ textAlign: "center" }}>
              <TopicCard>
                <strong>Contact / ติดต่อ</strong>
              </TopicCard>
            </Text>
            <Text>
              <ul>
                <li>สำนักงาน : 096-910-8498</li>
                <li>โทรสาร : 02-236-5598</li>
              </ul>
            </Text>
          </CardContainer>
        </ContactCardContainer>

        <SocialSection />
      </MainContainer>
    </>
  );
};

const ContactCardContainer = styled.div`
  width: 100%;
  max-width: 1000px;
  margin: auto;
  display: flex;
  justify-content: space-evenly;
  gap: 20px;

  @media (max-width: ${MobileSize}px) {
    padding: 10px;
    flex-direction: column;
  }
`;

const CardContainer = styled.div`
  background: white;
  border-radius: 40px;
  padding: 40px;
  width: 100%;
  max-width: 500px;
`;

const TopicCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export default ContactUs;
